export const LATITUDE = /^[-+]?([1-8]?\d(.\d+)?|90(.0+)?)$/;
export const LONGITUDE = /^[-+]?([1]?\d?\d(.\d+)?|180(.0+)?)$/;
